Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var core_1 = require("@emotion/core");

exports.Spinner = function () {
  var spinnerStyle = {
    animation: 'spin .75s linear infinite',
    borderColor: 'rgba(0,0,0,0.3)',
    borderRadius: '50%',
    borderTopColor: 'white',
    borderStyle: 'solid',
    borderTopWidth: '2px',
    borderWidth: '2px',
    display: 'inline-block',
    height: '24px',
    width: '24px',
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg) }'
      }
    }
  };
  return core_1.jsx("div", {
    css: spinnerStyle
  });
};